/**
 * Interface for timezone objects
 */
export interface Timezone {
    key: string;
    label: string;
    offset: string;
}

export const TIMEZONES: Timezone[] = [
    { key: 'Etc/UTC', label: 'UTC', offset: 'UTC' },
    { key: 'Exchange', label: 'Exchange', offset: 'UTC' },
    { key: 'Pacific/Honolulu', label: 'Honolulu', offset: 'UTC-10' },
    { key: 'America/Anchorage', label: 'Anchorage', offset: 'UTC-8' },
    { key: 'America/Juneau', label: 'Juneau', offset: 'UTC-8' },
    { key: 'America/Los_Angeles', label: 'Los Angeles', offset: 'UTC-7' },
    { key: 'America/Phoenix', label: 'Phoenix', offset: 'UTC-7' },
    { key: 'America/Vancouver', label: 'Vancouver', offset: 'UTC-7' },
    { key: 'America/Denver', label: 'Denver', offset: 'UTC-6' },
    { key: 'America/Mexico_City', label: 'Mexico City', offset: 'UTC-6' },
    { key: 'America/El_Salvador', label: 'San Salvador', offset: 'UTC-6' },
    { key: 'America/Bogota', label: 'Bogota', offset: 'UTC-5' },
    { key: 'America/Chicago', label: 'Chicago', offset: 'UTC-5' },
    { key: 'America/Lima', label: 'Lima', offset: 'UTC-5' },
    { key: 'America/Caracas', label: 'Caracas', offset: 'UTC-4' },
    { key: 'America/New_York', label: 'New York', offset: 'UTC-4' },
    { key: 'America/Santiago', label: 'Santiago', offset: 'UTC-4' },
    { key: 'America/Toronto', label: 'Toronto', offset: 'UTC-4' },
    { key: 'America/Buenos_Aires', label: 'Buenos Aires', offset: 'UTC-3' },
    { key: 'America/Sao_Paulo', label: 'Sao Paulo', offset: 'UTC-3' },
    { key: 'Atlantic/Reykjavik', label: 'Reykjavik', offset: 'UTC' },
    { key: 'Africa/Casablanca', label: 'Casablanca', offset: 'UTC+1' },
    { key: 'Europe/Dublin', label: 'Dublin', offset: 'UTC+1' },
    { key: 'Africa/Lagos', label: 'Lagos', offset: 'UTC+1' },
    { key: 'Europe/Lisbon', label: 'Lisbon', offset: 'UTC+1' },
    { key: 'Europe/London', label: 'London', offset: 'UTC+1' },
    { key: 'Africa/Tunis', label: 'Tunis', offset: 'UTC+1' },
    { key: 'Europe/Amsterdam', label: 'Amsterdam', offset: 'UTC+2' },
    { key: 'Europe/Belgrade', label: 'Belgrade', offset: 'UTC+2' },
    { key: 'Europe/Berlin', label: 'Berlin', offset: 'UTC+2' },
    { key: 'Europe/Bratislava', label: 'Bratislava', offset: 'UTC+2' },
    { key: 'Europe/Brussels', label: 'Brussels', offset: 'UTC+2' },
    { key: 'Europe/Budapest', label: 'Budapest', offset: 'UTC+2' },
    { key: 'Europe/Copenhagen', label: 'Copenhagen', offset: 'UTC+2' },
    { key: 'Africa/Johannesburg', label: 'Johannesburg', offset: 'UTC+2' },
    { key: 'Europe/Luxembourg', label: 'Luxembourg', offset: 'UTC+2' },
    { key: 'Europe/Madrid', label: 'Madrid', offset: 'UTC+2' },
    { key: 'Europe/Malta', label: 'Malta', offset: 'UTC+2' },
    { key: 'Europe/Oslo', label: 'Oslo', offset: 'UTC+2' },
    { key: 'Europe/Paris', label: 'Paris', offset: 'UTC+2' },
    { key: 'Europe/Prague', label: 'Prague', offset: 'UTC+2' },
    { key: 'Europe/Rome', label: 'Rome', offset: 'UTC+2' },
    { key: 'Europe/Stockholm', label: 'Stockholm', offset: 'UTC+2' },
    { key: 'Europe/Vienna', label: 'Vienna', offset: 'UTC+2' },
    { key: 'Europe/Warsaw', label: 'Warsaw', offset: 'UTC+2' },
    { key: 'Europe/Zurich', label: 'Zurich', offset: 'UTC+2' },
    { key: 'Europe/Athens', label: 'Athens', offset: 'UTC+3' },
    { key: 'Asia/Bahrain', label: 'Bahrain', offset: 'UTC+3' },
    { key: 'Europe/Bucharest', label: 'Bucharest', offset: 'UTC+3' },
    { key: 'Africa/Cairo', label: 'Cairo', offset: 'UTC+3' },
    { key: 'Europe/Helsinki', label: 'Helsinki', offset: 'UTC+3' },
    { key: 'Europe/Istanbul', label: 'Istanbul', offset: 'UTC+3' },
    { key: 'Asia/Jerusalem', label: 'Jerusalem', offset: 'UTC+3' },
    { key: 'Asia/Kuwait', label: 'Kuwait', offset: 'UTC+3' },
    { key: 'Europe/Moscow', label: 'Moscow', offset: 'UTC+3' },
    { key: 'Africa/Nairobi', label: 'Nairobi', offset: 'UTC+3' },
    { key: 'Asia/Nicosia', label: 'Nicosia', offset: 'UTC+3' },
    { key: 'Asia/Qatar', label: 'Qatar', offset: 'UTC+3' },
    { key: 'Europe/Riga', label: 'Riga', offset: 'UTC+3' },
    { key: 'Asia/Riyadh', label: 'Riyadh', offset: 'UTC+3' },
    { key: 'Europe/Tallinn', label: 'Tallinn', offset: 'UTC+3' },
    { key: 'Europe/Vilnius', label: 'Vilnius', offset: 'UTC+3' },
    { key: 'Asia/Tehran', label: 'Tehran', offset: 'UTC+3:30' },
    { key: 'Asia/Dubai', label: 'Dubai', offset: 'UTC+4' },
    { key: 'Asia/Muscat', label: 'Muscat', offset: 'UTC+4' },
    { key: 'Asia/Ashgabat', label: 'Ashgabat', offset: 'UTC+5' },
    { key: 'Asia/Karachi', label: 'Karachi', offset: 'UTC+5' },
    { key: 'Asia/Colombo', label: 'Colombo', offset: 'UTC+5:30' },
    { key: 'Asia/Kolkata', label: 'Kolkata', offset: 'UTC+5:30' },
    { key: 'Asia/Kathmandu', label: 'Kathmandu', offset: 'UTC+5:45' },
    { key: 'Asia/Almaty', label: 'Almaty', offset: 'UTC+6' },
    { key: 'Asia/Dhaka', label: 'Dhaka', offset: 'UTC+6' },
    { key: 'Asia/Yangon', label: 'Yangon', offset: 'UTC+6:30' },
    { key: 'Asia/Bangkok', label: 'Bangkok', offset: 'UTC+7' },
    { key: 'Asia/Ho_Chi_Minh', label: 'Ho Chi Minh', offset: 'UTC+7' },
    { key: 'Asia/Jakarta', label: 'Jakarta', offset: 'UTC+7' },
    { key: 'Asia/Chongqing', label: 'Chongqing', offset: 'UTC+8' },
    { key: 'Asia/Hong_Kong', label: 'Hong Kong', offset: 'UTC+8' },
    { key: 'Asia/Manila', label: 'Manila', offset: 'UTC+8' },
    { key: 'Australia/Perth', label: 'Perth', offset: 'UTC+8' },
    { key: 'Asia/Shanghai', label: 'Shanghai', offset: 'UTC+8' },
    { key: 'Asia/Singapore', label: 'Singapore', offset: 'UTC+8' },
    { key: 'Asia/Taipei', label: 'Taipei', offset: 'UTC+8' },
    { key: 'Asia/Seoul', label: 'Seoul', offset: 'UTC+9' },
    { key: 'Asia/Tokyo', label: 'Tokyo', offset: 'UTC+9' },
    { key: 'Australia/Adelaide', label: 'Adelaide', offset: 'UTC+9:30' },
    { key: 'Australia/Brisbane', label: 'Brisbane', offset: 'UTC+10' },
    { key: 'Australia/Sydney', label: 'Sydney', offset: 'UTC+10' },
    { key: 'Pacific/Norfolk', label: 'Norfolk Island', offset: 'UTC+11' },
    { key: 'Pacific/Auckland', label: 'New Zealand', offset: 'UTC+12' },
    { key: 'Pacific/Chatham', label: 'Chatham Islands', offset: 'UTC+12:45' },
    { key: 'Pacific/Tokelau', label: 'Tokelau', offset: 'UTC+13' },
];
